import React from 'react';

const TranslateWidget = ({ isEditMode, onRemove }) => {
  return (
    <div className="w-full h-full p-4 flex flex-col items-center justify-center text-white/80">
      <div className="text-xl mb-2">英语翻译小组件</div>
      <div className="text-sm">支持多语言极速智能翻译</div>
      {isEditMode && (
        <button
          onClick={onRemove}
          className="absolute -top-2 -right-2 w-6 h-6 bg-red-500 rounded-full flex items-center justify-center text-white opacity-0 group-hover:opacity-100 transition-opacity z-10"
        >
          ✕
        </button>
      )}
    </div>
  );
};

export default TranslateWidget;
